<div
  class="udex-grid udex-mx-auto"
  data-cy="search-pagination">
  @if (model$ | async; as model) {
    <dcp-pagination
      class="udex-mx-auto udex-py-40"
      (viewPageEvent)="viewPage($event)"
      [pagination]="model.pagination">
    </dcp-pagination>
  }
</div>
